// extracted by mini-css-extract-plugin
module.exports = {"superImage":"super_superImage__zgBcD","super":"super_super__Cg7yH","superContent":"super_superContent__jVGqu","blink":"super_blink__1PLa5"};